<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6 mb-base" v-for="(stat, index) in statisticsCards" :key="index">
        <statistics-card-line
          :icon="stat.icon"
          :statistic="GetAllstatistics[stat.countKey] || 0"
          :statisticTitle="stat.title"
          :chartData="[]"
          :color="stat.color"
          :hideChart="true" 
          type="area"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <vx-card title="طلبات الخدمات" class="mb-base p-4" code-toggler>
          <div class="mt-5">
            <chartjs-component-bar-chart ref="chart1" :height="250" :data="data" :options="options"></chartjs-component-bar-chart>
          </div>
          <template slot="codeContainer"></template>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2">
        <vx-card title="اعلانات عقارية معروضه" class="mb-base p-4" code-toggler>
          <div class="mt-5">
            <chartjs-component-bar-chart ref="chart2" :height="250" :data="data2" :options="options2"></chartjs-component-bar-chart>
          </div>
          <template slot="codeContainer"></template>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <vx-card title="خدمات عقارية مطلوبة" class="mb-base p-4" code-toggler>
          <div class="mt-5">
            <chartjs-component-bar-chart ref="chart3" :height="250" :data="data3" :options="options3"></chartjs-component-bar-chart>
          </div>
          <template slot="codeContainer"></template>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2">
        <vx-card title="المستخدمين الحاليين علي الموقع" class="mb-base p-4" code-toggler>
          <div class="mt-5">
            <chartjs-component-bar-chart ref="chart4" :height="250" :data="data4" :options="options4"></chartjs-component-bar-chart>
          </div>
          <template slot="codeContainer"></template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import ChartjsComponentBarChart from "./charts-components/ChartjsComponentBarChart.vue";
import moduleHome from "@/store/Home/moduleHome.js";

export default {
  components: {
    StatisticsCardLine,
    ChartjsComponentBarChart,
  },
  data() {
    return {
      users:0,
      brokers:0,
      sp:0,
      propertiesThisWeek:0,
      ServiceRequestsThisWeek:0,
      statisticsCards: [
        { icon: "FileTextIcon", countKey: "CustomersCount", title: "باحثين عن عقار", color: "" },
        { icon: "ClockIcon", countKey: "ServiceProvidersCount", title: "مقدمين خدمات ", color: "success" },
        { icon: "UserCheckIcon", countKey: "BrokersCount", title: "وسيط عقاري", color: "danger" },
        { icon: "UserPlusIcon", countKey: "ServicesRequestCount", title: "طلبات خدمات ", color: "warning" },
        { icon: "ClipboardIcon", countKey: "PropertiesCount", title: "اعلانات عقاريه", color: "warning" },
        { icon: "MessageSquareIcon", countKey: "OffersAcceptedCount", title: "عروض الخدمات العقاريه", color: "warning" }
      ],
      data: {
        labels: ["طلبات الخدمات"],
        datasets: [{
          label: "طلبات خدمات  تمت خلال الاسبوع",
          backgroundColor: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
          data: [],
          fontFamily: "Almarai"
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 500,
              stepSize: 100,
              fontFamily: "Almarai"
            }
          }],
          xAxes: [{
            ticks: {
              fontFamily: "Almarai"
            }
          }]
        },
        legend: {
          labels: {
            fontFamily: 'Almarai, sans-serif'
          }
        }
      },
      data2: {
        labels: ["الاعلانات العقارية"],
        datasets: [{
          label: "اعلانات عقارية معروضه خلال الاسبوع",
          backgroundColor: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#6495ED", "#DE3163", "#DFFF00"],
          data: [],
          fontFamily: "Almarai"
        }]
      },
      options2: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 500,
              stepSize: 100,
              fontFamily: "Almarai"
            }
          }],
          xAxes: [{
            ticks: {
              fontFamily: "Almarai"
            }
          }]
        },
        legend: {
          labels: {
            fontFamily: 'Almarai, sans-serif'
          }
        }
      },
      data3: {
        labels: ["طلب تطوير عقاري", "مساهمه عقارية", "طلبات خاصة", "طلبات ادارة الملاك", "التقيم العقاري"],
        datasets: [{
          label: "خدمات عقارية مطلوبة خلال الاسبوع",
          backgroundColor: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#DE3163"],
          data: [],
          fontFamily: "Almarai"
        }]
      },
      options3: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 500,
              stepSize: 100,
              fontFamily: "Almarai"
            }
          }],
        },
        legend: {
          labels: {
            fontFamily: 'Almarai, sans-serif'
          }
        }
      },
      data4: {
        labels: ["باحث عن عقار", "عقاري", "مقدم خدمات منزلية"],
        datasets: [{
          label: "المستخدمين الحاليين علي الموقع ",
          backgroundColor: ["#7367F0", "#28C76F", "#EA5455"],
          data: [],
          fontFamily: "Almarai"
        }]
      },
      options4: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 500,
              stepSize: 100,
              fontFamily: "Almarai"
            }
          }],
          xAxes: [{
            ticks: {
              fontFamily: "Almarai"
            }
          }]
        },
        legend: {
          labels: {
            fontFamily: 'Almarai, sans-serif'
          }
        }
      }
    };
  },
  computed: {
    GetAllstatistics() {
      return this.$store.state.moduleHome.statistics || {};
    }
  },
  created() {
    if (!moduleHome.isRegistered) {
      this.$store.registerModule("moduleHome", moduleHome);
      moduleHome.isRegistered = true;
    }
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("moduleHome/fetchDataListItems")
        .then((res) => {
          console.log('Fetched data:', res.data.data);
          this.users=res.data.data.CustomersCount;
          this.brokers=res.data.data.BrokersCount;
          this.sp=res.data.data.ServiceProvidersCount;
          this.propertiesThisWeek=res.data.data.propertiesThisWeek;
          this.ServiceRequestsThisWeek=res.data.data.ServiceRequestsThisWeek;
          console.log('this.ServiceRequestsThisWeek:', this.ServiceRequestsThisWeek);
          this.data4.datasets[0].data = [this.users, this.brokers, this.sp]; 
          this.data2.datasets[0].data = [ this.propertiesThisWeek];
          this.data.datasets[0].data = [ this.ServiceRequestsThisWeek];
          this.$nextTick(() => {
            // Force chart re-render
            this.$refs.chart4.renderChart(this.data4, this.options4);
            this.$refs.chart2.renderChart(this.data2, this.options2);
            this.$refs.chart1.renderChart(this.data, this.options);
            
          });
        })
        .catch(err => {
          console.error('Error fetching data:', err);
        });
    },
    updateChartData(chartData, data, labelKey, dataKey) {
      debugger;
      chartData.labels = [];
      chartData.datasets[0].data = [];

      for (let i = 0; i < data.length; i++) {
        chartData.labels.push(data[i][labelKey]);
        chartData.datasets[0].data.push(data[i][dataKey]);
      }
      
    },
    // reRenderCharts() {
    //   this.$refs.chart1.renderChart();
    //   this.$refs.chart2.renderChart();
    //   this.$refs.chart3.renderChart();
    //   this.$refs.chart4.renderChart();
    // }
  },
  // watch: {
  //   data: {
  //     handler() {
  //       this.reRenderCharts();
  //     },
  //     deep: true
  //   },
  //   data2: {
  //     handler() {
  //       this.reRenderCharts();
  //     },
  //     deep: true
  //   },
  //   data3: {
  //     handler() {
  //       this.reRenderCharts();
  //     },
  //     deep: true
  //   },
  //   data4: {
  //     handler() {
  //       this.reRenderCharts();
  //     },
  //     deep: true
  //   }
  // }
};
</script>

<style lang="scss">
.statistics-card-line .card-title {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.statisticTitle {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chartjs-chart {
  font-family: 'Elmarrai';
}
.chartjs-chart .chartjs-text {
  font-family: 'Elmarrai';
}
.chartjs-chart .chartjs-text {
  font-family: 'Elmarrai', sans-serif !important;
}
</style>
